module.exports = __webpack_public_path__ + "static/assets/124ea6269c267395123ec9f1d2c5c587.png";